import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { css, StyleSheet } from 'aphrodite';
import { stylePropType, TSS_BLACK } from 'tss-core-lib-common';
import withHandlers from 'recompose/withHandlers';
import Icon from 'react-svg-ikon';

import { IMG_ICON_CHEVRON_DOWN_SMALL, IMG_ICON_CHEVRON_UP_SMALL } from '../../img/icons';

import './table.css';

var styles = void 0;
var enhance = withHandlers({
  onClick: function onClick(props) {
    return function () {
      return props.onSort && props.onSort(props.id, !props.sortDesc);
    };
  }
});
var Header = function Header(_ref) {
  var intl = _ref.intl,
      label = _ref.label,
      labelKey = _ref.labelKey,
      sortable = _ref.sortable,
      centered = _ref.centered,
      sortDesc = _ref.sortDesc,
      isSorting = _ref.isSorting,
      style = _ref.style,
      render = _ref.render,
      onClick = _ref.onClick;

  var sortableProps = sortable ? {
    role: 'button',
    tabIndex: 0,
    onClick: onClick
  } : {};

  var sortingIcon = void 0;
  if (sortable) {
    if (sortDesc) {
      sortingIcon = React.createElement(Icon, {
        key: 'down',
        src: IMG_ICON_CHEVRON_DOWN_SMALL,
        stroke: isSorting ? TSS_BLACK(0.7) : TSS_BLACK(0.2),
        className: 'tss-table__sorting-arrow ' + css(styles.sortingArrow, isSorting && styles.activeSortingArrow)
      });
    } else {
      sortingIcon = React.createElement(Icon, {
        key: 'up',
        src: IMG_ICON_CHEVRON_UP_SMALL,
        stroke: isSorting ? TSS_BLACK(0.7) : TSS_BLACK(0.2),
        className: 'tss-table__sorting-arrow ' + css(styles.sortingArrow, isSorting && styles.activeSortingArrow)
      });
    }
  }

  var content = void 0;
  var title = '';
  if (render) {
    content = render();
  }

  if (!content) {
    if (label) {
      content = label;
      title = content;
    } else if (labelKey) {
      content = React.createElement(FormattedMessage, { id: labelKey });
      title = intl.formatMessage({ id: labelKey });
    }
    content = React.createElement(
      'span',
      {
        title: title,
        className: css(styles.headerText, centered && styles.headerTextCentered)
      },
      content || ''
    );
  }

  return React.createElement(
    'div',
    Object.assign({
      className: 'tss-table__cell ' + css(styles.column, styles.header, sortable && styles.sortableHeader, style)
    }, sortableProps),
    content,
    sortingIcon
  );
};

Header.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // eslint-disable-line
  intl: intlShape.isRequired,
  label: PropTypes.string,
  labelKey: PropTypes.string,
  sortable: PropTypes.bool,
  centered: PropTypes.bool,
  sortDesc: PropTypes.bool,
  isSorting: PropTypes.bool,
  style: stylePropType,
  render: PropTypes.func,
  onClick: PropTypes.func
};

Header.defaultProps = {
  id: null,
  label: '',
  labelKey: null,
  sortable: false,
  centered: false,
  sortDesc: null,
  isSorting: false,
  style: null,
  render: null,
  onClick: null
};

styles = StyleSheet.create({
  header: {
    fontSize: '1.2rem',
    color: TSS_BLACK(),
    textTransform: 'uppercase',
    padding: '1.3rem 1.2rem 1.1rem 1.2rem',
    display: 'flex',
    alignItems: 'flex-end',
    overflow: 'hidden'
  },

  sortableHeader: {
    cursor: 'pointer',

    ':hover > .tss-table__sorting-arrow': {
      opacity: 1
    },

    ':hover': {
      backgroundColor: 'rgba( 255, 255, 255, 0.7 )'
    }
  },

  headerText: {
    flex: '1 0 1%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  headerTextCentered: {
    textAlign: 'center'
  },

  column: {
    flex: '1 1 1%',

    ':first-child': {
      paddingLeft: '2.4rem'
    }
  },

  sortingArrow: {
    opacity: 0
  },

  activeSortingArrow: {
    opacity: 1
  }
});

export default enhance(injectIntl(Header));